import { getWindowConfig, } from '~/utils/env';
import { MoveIn, } from './move-in';

MoveIn('#app', (s) => getWindowConfig(s));
